import "./App.css";
import "./Sidebar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login";
import HomeComponent from "./components/Home";
import ChangePassword from "./components/ChangePassword";
import UserList from "./components/UserList";
import UserEdit from "./components/UserEdit";
import Main from "./components/layout/Main";
import RackList from "./components/racks/RackList";
import RackView from "./components/racks/RackView";
import Products from "./components/products/Products";
import Productcategory from "./components/category/Productcategory";
import Productcategoryview from "./components/category/Productcategoryview";
import ProductView from "./components/products/ProductView";
import ProductInventory from "./components/inventory/ProductInventory";
import Myprofile from "./components/myprofile";
import ProductInventorylineitem from "./components/inventory/ProductInventorylineitem";
import FactoryList from "./components/factory/factorylist";
import FactoryView from "./components/factory/factoryview";
import InventoryCheckout from "./components/inventory/checkout";
import UserView from "./components/UserView";
import ResetPassword from "./components/ResetPassword";
import ForgetPassword from "./components/ForgetPassword";
import Checkin from "./components/inventory/Checkin";
import Error from "./components/Error";
import WareHouse from "./components/warehouse/Warehouse";
import WarehouseView from "./components/warehouse/WarehouseView";
import WarehouseCreate from "./components/warehouse/WarehouseCreate";
import CreateProducts from "./components/products/CreateProducts";
import ProductDetailsReports from "./components/reports/ProductDetailsReports";
import AvailableInventoryReports from "./components/reports/AvailableInventoryReports";
import Gallary from "./components/Gallary";
import ExportData from "./components/export/ExportData";
import { usePermission } from "./components/context/PermissionContext";
import { useEffect, useState } from "react";

function App() {
  const { permissionData, userInfo } = usePermission();
  const [user , setUser] = useState();
  useEffect(() => {
    setUser(userInfo);
  }, [userInfo]);

  console.log('permissionData-->',permissionData);
  
  const {
    Home,
    Factory,
    Warehouse,
    Rack,
    Product,
    Product_Inventory,
    Inventory_Report,
    Transaction_Report,
    Product_Category,
    My_Profile,
  } = permissionData;

  const errorMessage = "Access Denied: You do not have permission to view this page. Please contact the administrator."

  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/** @Author shivam shrivastava */}

          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password/:email" element={<ResetPassword />} />
          {/** @Author shivam shrivastava */}
          <Route path="/" element={<Main />}>
          {userInfo && <>
            <Route index 
              element={
                userInfo?.userrole === "ADMIN" || Home?.can_read 
                ? <HomeComponent />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              } 
            />

            <Route 
              path="/users"
              element={
                userInfo?.userrole === "ADMIN" ? (
                  <UserList />
                ) : (
                  <Navigate to="/404" replace />
                )
              }
            />

            <Route
              path="users/e"
              element={
                userInfo?.userrole === "ADMIN"
                ? <UserEdit />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              }
            />

            <Route
              path="users/:id/e"
              element={userInfo?.userrole === "ADMIN"
                ? <UserEdit />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              }
            />
            {/* SHIVAM SHRIVASTAVA CODE START  */}

            {/******* START an Warehouse (Shakib) ******/}
            <Route
              path="/warehouse"
              element={
                userInfo?.userrole === "ADMIN" || Warehouse?.can_read ? (
                  <WareHouse />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/warehouse/e"
              element={
                userInfo?.userrole === "ADMIN" || Warehouse?.can_read ? (
                  <WarehouseCreate />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="warehouse/:id"
              element={
                userInfo?.userrole === "ADMIN" || Warehouse?.can_read ? (
                  <WarehouseView />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="warehouse/:id/e"
              element={
                userInfo?.userrole === "ADMIN" || Warehouse?.can_read ? (
                  <WarehouseCreate />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />
            {/******* END an Warehouse (Shakib) ******/}

            {/******* Start an Rack (Shakib) ******/}
            <Route
              path="/racks"
              element={
                userInfo?.userrole === "ADMIN" || Rack?.can_read ? (
                  <RackList />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="rack/:id"
              element={
                userInfo?.userrole === "ADMIN" || Rack?.can_read ? (
                  <RackView />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />
            {/******* End an Rack (Shakib)  ******/}

            {/******* Start an Product Inventory (Shakib)  ******/}
            <Route
              path="/productinventory"
              element={
                userInfo?.userrole === "ADMIN" ||
                Product_Inventory?.can_read ? (
                  <ProductInventory />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/inventory-available"
              element={
                userInfo?.userrole === "ADMIN" || Inventory_Report?.can_read ? (
                  <AvailableInventoryReports />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/inventory-transaction"
              element={
                userInfo?.userrole === "ADMIN" ||
                Transaction_Report?.can_read ? (
                  <ProductDetailsReports />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/checkin"
              element={
                userInfo?.userrole === "ADMIN" ||
                Product_Inventory?.can_read ? (
                  <Checkin />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />
            {/******* End an Product Inventory (Shakib)  ******/}

            <Route
              path="/products"
              element={
                userInfo?.userrole === "ADMIN" || Product?.can_read ? (
                  <Products />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/productview/:id"
              element={
                userInfo?.userrole === "ADMIN" || Product?.can_read ? (
                  <ProductView />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/createproduct"
              element={
                userInfo?.userrole === "ADMIN" || Product?.can_read ? (
                  <CreateProducts />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route path="/productcategory" element={<Productcategory />} />
            <Route path="/export" element={<ExportData />} />

            <Route
              path="/productcategoryview"
              element={
                userInfo?.userrole === "ADMIN" || Product_Category?.can_read ? (
                  <Productcategoryview />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/myprofile"
              element={
                userInfo?.userrole === "ADMIN" ||
                My_Profile?.can_read ? (
                  <Myprofile />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route
              path="/ProductInventorylineitem"
              element={
                userInfo?.userrole === "ADMIN" || Product_Inventory?.can_read
                ? <ProductInventorylineitem />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              }
            />

            <Route
              path="/factory"
              element={
                userInfo?.userrole === "ADMIN" || Factory?.can_read ? (
                  <FactoryList />
                ) : (
                  <div className="mt-5 mx-5 alert alert-danger">
                    {errorMessage}
                  </div>
                )
              }
            />

            <Route 
              path="/factories/:id"
              element={
                userInfo?.userrole === "ADMIN" || Factory?.can_read
                ? <FactoryView />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              }
            />

            <Route 
              path="/checkout"
              element={userInfo?.userrole === "ADMIN" || Product_Inventory?.can_read
                ? <InventoryCheckout />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              }
            />

            <Route
              path="/userview/:id"
              element={
                userInfo?.userrole === "ADMIN"
                ? <UserView />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              }
            />

            {/******** Show an User By Id *******/}
            <Route path="/changepassword/:id"
              element={
                userInfo?.userrole === "ADMIN" || My_Profile?.can_edit
                ? <ChangePassword />
                : <div className="mt-5 mx-5 alert alert-danger">{errorMessage}</div>
              } 
            />

            {/* Gallary module | 04-Fab-2025  | by sarfraj */}
            {/* <Route path="/gallary" element={<Gallary />} /> */}

            <Route path="*" element={<Navigate to="/404" />} />
          </>}
          </Route>
          <Route path="/404" element={<Error />} />
        </Routes>
      </Router>
    </>
  );
}
export default App;
